<template>
  <v-container>
    <v-layout row align-center justify-center>
      <v-flex xs10 sm10 md9 lg6>
        <Profile v-bind:titleflag="'FillProfile'" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
/*Import components to ingust in profile */
import Profile from "../components/Profile/Profile/Profile";

/* Profile Controller to impliment the user profile logic */
export default {
  components: {
    Profile
  },
  data() {
    return {
      isLoader: true
    };
  },
  mounted() {
    setTimeout(() => {
      this.isLoader = false;
    }, 2000);
  },
  methods: {}
};
</script>
